import '../../App.css';
import React, {Component, Container} from 'react';
import {Row,Col,Image,Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Card from './card';
import NavBarTop from "./navbar";
import Footer from "./footer";


class ISWCPastComp extends Component {
  constructor(props){
    super(props);
    this.state = {
       
    };

    this.setval = this.setval.bind(this)
  }

  setval(obj){
    this.setState(obj)
  }
  componentDidMount(){
    document.title="International Speech and Writing Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/iswc-logo.PNG"
    link2.href="/assets/iswc-logo.PNG"
    this.props.setval({comp:"iswc",lang:"en"}) 
  }      
      
  render(){
    return (
      <div>
      <div className="home-content-div" style={{textAlign:"justify",textJustify:"inter-word", padding:"4% 6%",fontFamily:"Arial"}}>
        
        <h2>Past Competitions</h2>

        <div style={{width:"100%",display:"flex",flexDirection:"row",margin:"10px",padding:"10px",cursor:"pointer",border:"1px solid rgba(0,0,0,0.3)"}} onClick={(e)=>{
                window.open("http://youngartistcompetition.org/iyfao")
            }}>
           <div style={{width:"40%",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <img src="/assets/iyfao-poster-2024.png" width="40%" />
            </div>
            <div style={{width:"60%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.5rem"}} >
                <b><i>{"International Young Fine Art Artist Open Competition"}</i></b>
            </div>
        </div>

           
        
      </div>
      </div>
    );
  }
  }
  

export default ISWCPastComp;
